import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { BpgCommonService } from './bpg-common/services/bpg-common.service';
import { environment } from 'src/environments/environment';
import { environmentLocal } from 'src/environments/environment.local';
import { environmentQA } from 'src/environments/environment.qa';
import { environmentPROD } from 'src/environments/environment.prod';
import * as i0 from "@angular/core";
import * as i1 from "./bpg-common/services/bpg-common.service";
import * as i2 from "./environment/services/environment.configuration";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(bpgCommonService, environment) {
        this.bpgCommonService = bpgCommonService;
        this.environment = environment;
    }
    AuthGuard.prototype.canActivate = function (_next, _state) {
        // Ensure QA/PROD auth flow always runs on erg host to keep PKCE session storage on one origin.
        var currentHostname = window.location.hostname;
        var redirectHost = this.environment.envName === 'qa' && currentHostname === 'qa.bpg.toyota.com'
            ? 'qa.erg.toyota.com'
            : this.environment.envName === 'prod' && currentHostname === 'bpg.toyota.com'
                ? 'erg.toyota.com'
                : null;
        if (redirectHost) {
            var url = new URL(window.location.href);
            url.hostname = redirectHost;
            window.location.href = url.toString();
            return false;
        }
        //Check to run application locally or in staging/production using ADAL Authentication 
        var codefromurl = sessionStorage.getItem('codeResponse');
        var token = sessionStorage.getItem('id_token');
        var refreshToken = sessionStorage.getItem('refresh_token');
        var accessToken = sessionStorage.getItem('access_token');
        if (codefromurl != null && token != null && refreshToken != null && accessToken != null &&
            codefromurl !== undefined && token !== undefined && refreshToken !== undefined && accessToken !== undefined) {
            return true;
        }
        else if (codefromurl !== null && sessionStorage.getItem('id_token') === null) {
            return this.bpgCommonService.userLogin();
        }
        else {
            var baseLoginUrl = void 0;
            if (this.environment.envName === 'default' || this.environment.envName === 'local' || this.environment.envName === 'staging') {
                baseLoginUrl = environmentLocal.baseLoginUrl;
            }
            else if (this.environment.envName === 'qa') {
                baseLoginUrl = environmentQA.baseLoginUrl;
            }
            else if (this.environment.envName === 'prod') {
                baseLoginUrl = environmentPROD.baseLoginUrl;
            }
            localStorage.setItem("redirectURl", window.location.href);
            var redirectUrl = baseLoginUrl + environment.codeChallenge;
            window.location.href = redirectUrl;
            return true;
        }
    };
    AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.BpgCommonService), i0.ɵɵinject(i2.EnvironmentConfiguration)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
